import { useCallback, useReducer } from 'react';

import type { KenmerkLookup } from '../../types';
import {
  initialKenmerkSearchState,
  kenmerkSearchReducer,
} from './utils/reducer';
import buildKenmerkSearchMatches from './utils/buildKenmerkSearchMatches';

const useKenmerkSearch = (updatedKenmerkLookup: KenmerkLookup | null) => {
  const [state, dispatch] = useReducer(
    kenmerkSearchReducer,
    initialKenmerkSearchState,
  );

  const setOpenGroupName = useCallback((groupName: string | null) => {
    dispatch({ type: 'SET_OPEN_GROUP', groupName });
  }, []);

  const handleCollapseOpenGroup = useCallback(() => {
    dispatch({ type: 'COLLAPSE_GROUP' });
  }, []);

  const handleSearch = useCallback(
    (query: string) => {
      if (!updatedKenmerkLookup) return;

      if (!query.trim()) {
        dispatch({ type: 'CLEAR_SEARCH' });
        return;
      }

      dispatch({
        type: 'SEARCH',
        query,
        matches: buildKenmerkSearchMatches(updatedKenmerkLookup, query),
      });
    },
    [updatedKenmerkLookup],
  );

  const handlePreviousMatch = useCallback(() => {
    dispatch({ type: 'NAVIGATE', delta: -1 });
  }, []);

  const handleNextMatch = useCallback(() => {
    dispatch({ type: 'NAVIGATE', delta: 1 });
  }, []);

  return {
    openGroupName: state.openGroupName,
    activeKenmerkSearch: state.activeKenmerkSearch,
    kenmerkSearchNavigation: state.kenmerkSearchNavigation,
    setOpenGroupName,
    handleSearch,
    handlePreviousMatch,
    handleNextMatch,
    handleCollapseOpenGroup,
  };
};

export default useKenmerkSearch;
